import React, { useEffect, useState } from "react";
import { useIntercom } from "react-use-intercom";
import { observer } from "mobx-react";
import { useRootStore } from "app/useRootStore";
import { INTERCOM_SETTINGS } from "shared/constants/appConstants";

const BootstrapIntercom = observer((): null => {
    const [isChatOnAir, setIsChatOnAir] = useState(false);
    const {
        rootStore: {
            isAdmin,
            authStore: { isAuthenticated },
        },
    } = useRootStore();
    const { boot, shutdown, hide } = useIntercom();

    useEffect(() => {
        if (!INTERCOM_SETTINGS.isIntercomIdExist) return;

        if (isAuthenticated && !isChatOnAir) {
            boot();

            if (isAdmin && !INTERCOM_SETTINGS.isIntercomEnabledForInternalUser) {
                shutdown();
            }

            setIsChatOnAir(true);
        }

        if (isChatOnAir && !isAuthenticated) {
            shutdown();
            setIsChatOnAir(false);
        }
    }, [isAdmin, isChatOnAir, isAuthenticated, shutdown, boot, hide]);

    useEffect(() => {
        if (!INTERCOM_SETTINGS.isIntercomIdExist) return;

        return () => {
            shutdown();
        };
    }, [shutdown]);

    return null;
});

const IntercomClientIdGuard = (): JSX.Element | null => {
    if (!window.APP_SETTINGS.intercomClientId) return null;

    return <BootstrapIntercom />;
};

export default IntercomClientIdGuard;
